import {Component, ViewChild, TransferState, OnInit, AfterContentChecked, Inject, Input, AfterViewInit} from '@angular/core';
import {IS_BROWSER} from "@aparraga/ahoracrypto-client-common/src/app/common/utils/injectiontokens";
//import { SwiperConfigInterface, SwiperDirective } from 'ngx-swiper-wrapper';


@Component({
    selector: 'app-card-carousel',
    styleUrls: ['./card-carousel.component.scss'],
    templateUrl: './card-carousel.component.html',
    standalone: false
})
export class CardCarouselComponent implements AfterViewInit, AfterContentChecked {

  //@ViewChild(SwiperDirective) swiperView: SwiperDirective;

  @Input()
  itemsCarrousel: Array<any>;

  isInitSwiper: boolean;
  flagUpdateSwiper: boolean;

  constructor(
    protected cache: TransferState,
    @Inject(IS_BROWSER) protected isBrowser: boolean
  ) {
    this.itemsCarrousel = [];
  }

  ngAfterViewInit(): void {
    if (!this.isInitSwiper) {
      this.initSwiper();
    } else {
      this.flagUpdateSwiper = true;
    }
  }

  ngAfterContentChecked() {
    if (this.isBrowser && this.flagUpdateSwiper) {
      this.flagUpdateSwiper = false;
      //this.swiperView.update();
    }
  }

  initSwiper() {
    this.isInitSwiper = true;
    //this.swiperView.init();
    //this.swiperView.update();
  }

  /*
  public swiperCardsConfig: SwiperConfigInterface = {
    init: false,
    preloadImages: true,
    updateOnImagesReady: true,
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween: 24,
    slidesOffsetBefore: 45,
    slidesOffsetAfter: 45,
    freeMode: true,
    centerInsufficientSlides: true,
    breakpointsInverse: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  };

   */

}
